import Vue from 'vue';

import merge from 'deepmerge';

import Vuex from 'vuex';

import msg from './msg';

Vue.use(Vuex);

const config = {
  strict: true,
};

const finalStore = merge.all([
  config,
  msg,
]);


export default new Vuex.Store(finalStore);
